const PaymentStatusToggle = ({ options, value, disabled, onChange, label = "Payment Status" }) => (
  <div className="flex items-center gap-2 min-w-0">
    {label ? (
      <span className="text-[11px] sm:text-xs font-semibold text-gray-600 whitespace-nowrap">
        {label}
      </span>
    ) : null}
    <div className="flex shrink-0 rounded-lg border border-gray-300 overflow-hidden text-[11px] sm:text-xs font-semibold">
      {options.map((option, index) => {
        const selected = value === option.value
        return (
          <button
            key={option.value}
            type="button"
            disabled={disabled}
            onClick={() => onChange(option.value)}
            className={`min-w-[4.25rem] sm:min-w-[4.75rem] px-2.5 py-1.5 leading-tight transition ${
              index > 0 ? "border-l border-gray-300" : ""
            } ${
              selected
                ? "bg-blue-600 text-white"
                : "bg-white text-gray-600 hover:bg-gray-50"
            } ${disabled ? "opacity-70 cursor-not-allowed" : ""}`}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  </div>
)

export default PaymentStatusToggle
